import { render } from "./InvoiceSelect.vue?vue&type=template&id=6706289b"
import script from "./InvoiceSelect.vue?vue&type=script&lang=js"
export * from "./InvoiceSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__